import { useEffect, useState } from "react";

export const useIntersection = ({ id }: { id: string }) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  useEffect(() => {
    const element = document.querySelector(`[data-layer-id="${id}"]`);
    if (!element) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsIntersecting(entry.isIntersecting);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.5 },
    );
    observer.observe(element);
  }, []);

  return isIntersecting;
};
